module.exports = __webpack_public_path__ + "static/media/talentx-manager@3x.d6f88e37.png";